<div class="heading py-5">
  <h1 class="bold font-curve-large">Pagination</h1>
  <app-dependency-link></app-dependency-link>
</div>

<section>
  <app-ngb-pagination-demo></app-ngb-pagination-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>

<app-ngb-localization />
